var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1147_22155)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.5,
    cy: 12,
    rx: 6.5,
    ry: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM16.9005 10.3166C17.4436 9.81925 17.4806 8.97584 16.9833 8.4328C16.4859 7.88975 15.6425 7.85271 15.0995 8.35007L10.1767 12.8586L8.90054 11.6898C8.35749 11.1925 7.51409 11.2295 7.01673 11.7726C6.51938 12.3156 6.55642 13.159 7.09946 13.6564L9.27616 15.6499C9.78579 16.1167 10.5676 16.1167 11.0772 15.6499L16.9005 10.3166Z",
    fill: "#14B8FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1147_22155"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.ecad47b535ac6f3095809d18357e78ef.svg";
export { ForwardRef as ReactComponent };